import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';

export const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar showAnimations={false} />

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
      <h1 className="text-3xl font-bold mb-6" style={{ color: '#000000' }}>TERMS OF SERVICE</h1>
      <p className="mb-2" style={{ color: '#000000' }}>
        <strong>Effective Date:</strong> January 4th, 2025
      </p>
      <p className="mb-2" style={{ color: '#000000' }}>
        <strong>Last updated:</strong> July 21, 2026
      </p>
      <p className="mb-2" style={{ color: '#000000' }}>
        <strong>Operator:</strong> HFX LLC ("HFX", "FocusPips," "Us," "We")
      </p>
      <p className="mb-2" style={{ color: '#000000' }}>
        <strong>Website:</strong> https://focuspips.com/
      </p>
      <p className="mb-4" style={{ color: '#000000' }}>
        <strong>Contact:</strong> support@focuspips.com
      </p>
      <p className="mb-4 italic" style={{ color: '#000000' }}>
        We actively solicit feedback on our Terms of Service. Please send comments or questions to support@focuspips.com.
      </p>

      {/* 1. User's Acknowledgment and Acceptance of Terms */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>1. User's Acknowledgment and Acceptance of Terms</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          HFX LLC provides the FocusPips site and related services (collectively, the "Site") to you, the user, subject to your compliance with all the terms, conditions, and notices contained herein ("Terms of Service"), as well as any additional agreements or policies referenced.
        </p>
        <p className="mb-4 uppercase font-bold" style={{ color: '#4b5563' }}>
          BY USING THIS SITE, YOU AGREE TO BE BOUND BY THESE TERMS OF SERVICE. IF YOU DO NOT AGREE, PLEASE EXIT THE SITE IMMEDIATELY.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We reserve the right to modify these Terms of Service at any time without prior notice. Continued use of the Site after such modifications constitutes acceptance of the updated Terms.
        </p>
      </section>

      {/* 2. Description of Services */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>2. Description of Services</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips provides digital services including, but not limited to: trade journaling, performance analytics, sharing or publishing of trades, and related features.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We reserve the right to modify or discontinue any part of the Site without notice. Any new features or services will also be subject to these Terms.
        </p>

        {/* 2.1. Eligibility */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>2.1. Eligibility</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            You must be at least 18 years of age, or the age of legal majority in your jurisdiction of residence if higher, to create an account or use the Site. By using the Site, you represent and warrant that you meet this requirement and have the legal capacity to enter into a binding contract. We reserve the right to refuse registration, or to terminate an existing account, if we reasonably believe this requirement is not met.
          </p>
        </div>
      </section>

      {/* 3. Registration Data and Privacy */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>3. Registration Data and Privacy</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          To access certain features, you must create an account by providing accurate, current, and complete information. You agree to update your registration data as necessary.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We may disclose limited registration data to third parties as defined in our Privacy Policy.
        </p>
      </section>

      {/* 4. Conduct on Site */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>4. Conduct on Site</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You agree not to use the Site for unlawful, abusive, defamatory, infringing, or harmful purposes.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You shall not upload or distribute content that:
        </p>
        <ul className="list-none pl-8 mb-4">
          <li className="mb-2" style={{ color: '#4b5563' }}>– violates intellectual property rights;</li>
          <li className="mb-2" style={{ color: '#4b5563' }}>– contains malware or malicious code;</li>
          <li className="mb-2" style={{ color: '#4b5563' }}>– promotes hate or discrimination;</li>
          <li className="mb-2" style={{ color: '#4b5563' }}>– impersonates others;</li>
          <li className="mb-2" style={{ color: '#4b5563' }}>– constitutes spam or unauthorized solicitation.</li>
        </ul>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We may remove any content or terminate accounts that violate these Terms, at our sole discretion.
        </p>
      </section>

      {/* 5. Subscriptions */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>5. Subscriptions</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Subscriptions are sold on a prepaid basis. Access is granted for the subscription term only.
        </p>
      </section>

      {/* 6. Third Party Sites and Information */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>6. Third Party Sites and Information</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          The Site may contain links or references to third-party websites or services. We are not responsible for the content, legality, or accuracy of external sources and disclaim all liability arising from their use.
        </p>
      </section>

      {/* 7. Intellectual Property Information */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>7. Intellectual Property Information</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          All content, trademarks, and materials on the Site are the property of HFX LLC or its licensors. You may not copy, distribute, or modify any material without prior written consent.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          All FocusPips names, logos, and graphics are registered trademarks of HFX LLC. Nothing herein grants any right to use them without authorization.
        </p>

        {/* 7.1. Copyright / DMCA Notice-and-Takedown */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>7.1. Copyright / DMCA Notice-and-Takedown</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            HFX LLC respects the intellectual property rights of others and responds to notices of alleged copyright infringement in accordance with the Digital Millennium Copyright Act (17 U.S.C. § 512). If you believe that content on the Site infringes your copyright, send a written notice to support@focuspips.com containing:
          </p>
          <ol className="list-decimal pl-8 mb-4">
            <li className="mb-2" style={{ color: '#4b5563' }}>identification of the copyrighted work claimed to be infringed;</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>identification and location (URL) of the material claimed to be infringing;</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>your name, address, telephone number, and email address;</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>a statement that you have a good-faith belief that the use is not authorized by the copyright owner, its agent, or the law;</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>a statement, made under penalty of perjury, that the information in the notice is accurate and that you are the copyright owner or authorized to act on the owner's behalf; and</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>your physical or electronic signature.</li>
          </ol>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            HFX LLC will review each valid notice and, where appropriate, remove or disable access to the reported material and notify the user who posted it. HFX LLC may terminate, in appropriate circumstances, the accounts of users who are repeat infringers.
          </p>
        </div>
      </section>

      {/* 8. Accuracy of Information */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>8. Accuracy of Information</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          All information provided is for educational and entertainment purposes only. While accuracy is intended, FocusPips and its affiliates make no warranties as to the completeness, reliability, or timeliness of any content.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips is not responsible for the accuracy or reliability of any advice, opinion, or statement posted by users or third parties.
        </p>
      </section>

      {/* 9. Investment Decisions */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>9. Investment Decisions</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You acknowledge that you bear all risk for investment decisions based on Site information. FocusPips never recommends or advises on buying or selling any financial instrument. FocusPips / HFX LLC is not registered as an investment advisor, broker-dealer, commodity trading advisor, or financial institution in any jurisdiction, and is not registered with the CFTC or as an NFA member.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips and its affiliates may hold positions in the markets discussed. Verify all information independently with your broker before executing trades.
        </p>

        {/* 9.1. Unauthorized Trading Activities */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>9.1. Unauthorized Trading Activities</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            FocusPips is a journaling and analytics platform only. It does not execute, modify, or cancel trades and has no access to user funds or broker accounts.
          </p>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            In case of unauthorized trades, execution errors, or losses within your brokerage account, all liability lies exclusively with the broker.
          </p>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            By using FocusPips, you agree that:
          </p>
          <ul className="list-none pl-8 mb-4">
            <li className="mb-2" style={{ color: '#4b5563' }}>a. FocusPips has no trade execution capabilities.</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>b. FocusPips does not access or store broker credentials.</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>c. Any disputes about trade execution must be directed to your broker.</li>
            <li className="mb-2" style={{ color: '#4b5563' }}>d. FocusPips and HFX LLC bear no responsibility for broker or third-party platform behavior.</li>
          </ul>
        </div>

        {/* 9.2. Data Accuracy and Integration */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>9.2. Data Accuracy and Integration</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            FocusPips imports and analyzes trade data from various sources but does not guarantee its accuracy or completeness.
          </p>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            Users are solely responsible for verifying data consistency with their broker's records.
          </p>
        </div>

        {/* 9.3. Third-Party Integrations and API Connections */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>9.3. Third-Party Integrations and API Connections</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            Optional integrations with brokers or third-party APIs are read-only unless explicitly stated. FocusPips disclaims all liability for data mismatches, API errors, or losses arising from third-party systems.
          </p>
        </div>

        {/* 9.4. No Personal Solicitation or Direct Messaging */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>9.4. No Personal Solicitation or Direct Messaging</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            HFX LLC, FocusPips, and their representatives will never contact any user privately — by direct message, email outside official channels, WhatsApp, Telegram, or any other means — to solicit funds, offer personalized trading signals, or propose fund or account management services. Any account or profile engaging in such conduct, whether or not it displays FocusPips branding, is fraudulent and unaffiliated with HFX LLC. Users should report such accounts to the relevant platform and to support@focuspips.com.
          </p>
        </div>
      </section>

      {/* 10. Shared Trades */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>10. Shared Trades</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          By sharing content on FocusPips, you grant HFX LLC a worldwide, royalty-free license to use, display, and distribute such content as necessary to operate the Service. This license survives termination of your account solely to the extent necessary for HFX LLC to maintain records, comply with law, or operate previously published community content.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You must ensure you have full rights to any shared content. You indemnify FocusPips for claims arising from your postings.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips reserves the right to remove any content it deems unlawful, infringing, or objectionable. As stated in Section 8, any trade, commentary, or content shared by a user reflects that user's own views only and is not reviewed, verified, or endorsed by FocusPips or HFX LLC.
        </p>
      </section>

      {/* 11. Disclaimer of Warranties */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>11. Disclaimer of Warranties</h2>
        <p className="mb-4 uppercase font-bold" style={{ color: '#4b5563' }}>
          ALL SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE."
        </p>
        <p className="mb-4 uppercase font-bold" style={{ color: '#4b5563' }}>
          FOCUSPIPS DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We do not guarantee uninterrupted access, accuracy of data, or error-free operation.
        </p>

        {/* 11.1. Service Availability and Technical Issues */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>11.1. Service Availability and Technical Issues</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            Technical failures, maintenance periods, or service interruptions may occur. FocusPips shall not be liable for downtime, data loss, synchronization issues, or missed opportunities resulting from technical events.
          </p>
        </div>
      </section>

      {/* 12. Limitation of Liability */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>12. Limitation of Liability</h2>
        <p className="mb-4 uppercase font-bold" style={{ color: '#4b5563' }}>
          IN NO EVENT SHALL FOCUSPIPS OR HFX LLC BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOSS OF PROFITS OR DATA.
        </p>

        {/* 12.1. Maximum Liability */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>12.1. Maximum Liability</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            The maximum total liability of FocusPips or HFX LLC shall not exceed the amount you paid for your subscription during the twelve (12) months preceding the claim.
          </p>
        </div>
      </section>

      {/* 13. Indemnification */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>13. Indemnification</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You agree to defend and indemnify HFX LLC and its affiliates from any claims, damages, or expenses (including reasonable legal fees) arising from your use of the Site, your User Content, or violation of these Terms.
        </p>
      </section>

      {/* 14. Security and Password */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>14. Security and Password</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You are solely responsible for maintaining account confidentiality. FocusPips will never request your password. Unauthorized access due to weak or shared credentials is your responsibility.
        </p>

        {/* 14.1. Account Security and Third-Party Access */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>14.1. Account Security and Third-Party Access</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            All activity under your account is deemed to be yours. FocusPips disclaims liability for unauthorized access resulting from password sharing, API misconfiguration, or third-party connections.
          </p>
        </div>
      </section>

      {/* 15. International Use */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>15. International Use</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips makes no representation that materials are lawful outside the U.S. Accessing from territories where the content is illegal is prohibited. Users abroad are responsible for compliance with local laws.
        </p>
      </section>

      {/* 16. Termination of Use */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>16. Termination of Use</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We may terminate or suspend your account at any time, with or without notice, for any violation of these Terms. Upon termination, all access ceases immediately. Sections relating to intellectual property, disclaimers, limitation of liability, indemnification, and dispute resolution survive termination.
        </p>
      </section>

      {/* 17. Governing Law */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>17. Governing Law</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          These Terms are governed by the laws of the State of Wyoming, USA, without regard to conflict of law principles.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Both parties consent to the exclusive jurisdiction of courts located in Wyoming.
        </p>
        <p className="mb-4 font-bold" style={{ color: '#4b5563' }}>
          To the extent permitted by applicable law, any claim or dispute must be brought on an individual basis only, and not as part of any class, collective, or representative action, and not before a jury.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          For international users, these Terms remain governed solely by the laws of Wyoming.
        </p>

        {/* 17.1. Platform Compliance */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>17.1. Platform Compliance</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            FocusPips content is distributed across YouTube, Instagram, Facebook, Google, TikTok, and Telegram for educational and informational purposes only, in accordance with each platform's community guidelines and advertising policies. FocusPips is not affiliated with, sponsored by, or endorsed by any of these platforms. See our Risk Disclaimer for the full platform-compliance and anti-impersonation policy.
          </p>
        </div>
      </section>

      {/* 18. Notices */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>18. Notices</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          All notices must be in writing and directed to support@focuspips.com.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Announcements posted within the Site constitute valid notice at the time of publication.
        </p>
      </section>

      {/* 19. Entire Agreement */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>19. Entire Agreement</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          These Terms, together with our Privacy Policy and Risk Disclaimer, constitute the complete agreement between you and HFX LLC. Any modification must be in writing and signed by both parties, except for updates made by HFX LLC under Section 1.
        </p>
      </section>

      {/* 20. Miscellaneous */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>20. Miscellaneous</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Failure to enforce any right does not constitute waiver. If any clause is held invalid, the remainder remains enforceable.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          You may not assign your rights under these Terms. We may assign ours freely.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          We are excused from non-delivery or delay caused by events beyond our control, including war, fire, regulation, or network failure.
        </p>

        {/* 20.1. Data Retention */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>20.1. Data Retention</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            User data is retained as long as necessary to provide the service or as required by law. Upon account deletion, data will be removed within a reasonable timeframe except for legal or auditing purposes.
          </p>
        </div>

        {/* 20.2. Third-Party Beneficiaries */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>20.2. Third-Party Beneficiaries</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            Except as expressly provided herein, these Terms are for the sole benefit of you and HFX LLC and confer no rights or remedies on any third party, including brokers, prop firms, API providers, or other users.
          </p>
        </div>

        {/* 20.3. Electronic Communications and Signature */}
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2" style={{ color: '#000000' }}>20.3. Electronic Communications and Signature</h3>
          <p className="mb-4" style={{ color: '#4b5563' }}>
            By using the Site, you consent to receive communications from HFX LLC electronically and agree that any electronic signature, click-through acceptance, or in-app acknowledgment satisfies any legal requirement that such communications or agreements be made in writing, to the extent permitted by applicable law.
          </p>
        </div>
      </section>

      {/* 21. Contact Information */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>21. Contact Information</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips (HFX LLC)
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Email: support@focuspips.com
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Jurisdiction: State of Wyoming, USA
        </p>
      </section>

      {/* 22. Refunds and Cancellations */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4" style={{ color: '#000000' }}>22. Refunds and Cancellations</h2>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          All payments are final and non-refundable.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          FocusPips is not responsible for continued charges due to user inaction or failure to cancel an account. It is the user's responsibility to confirm cancellation before renewal.
        </p>
        <p className="mb-4" style={{ color: '#4b5563' }}>
          Nothing in this section is intended to exclude or limit any consumer right that cannot be lawfully waived under the mandatory law of your country of residence. Where any part of this no-refund policy conflicts with such mandatory law, it applies only to the extent permitted, without affecting the rest of these Terms.
        </p>
      </section>
        </div>
      </div>

      <Footer />
    </div>
  );
};
